import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyAycib-2edPYwWyE9iRkrzl-DEFtlZVE08",
  authDomain: "learnersrider.firebaseapp.com",
  projectId: "learnersrider",
  storageBucket: "learnersrider.firebasestorage.app",
  messagingSenderId: "988667786755",
  appId: "1:988667786755:web:78ed93bf965b6a6d240036"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);